import React, { FC } from 'react'
import ProtectedButton from '../components/ProtectedButton'

export const UseOldUI: FC<{}> = () => {
  return (
    <div className='h-100 text-center d-flex justify-content-center flex-column pb-5 mt-n5'>
      <h1>
        Page not yet available! Please use the{' '}
        <a target='_blank' href={`${window.location.origin}/onASConsole/login`} rel='noopener noreferrer'>
          old UI
        </a>{' '}
        for now
      </h1>
    </div>
  )
}

export const NodeLicenseUsed: FC<{ onClick: () => void; permissions: string[] }> = ({ onClick, permissions }) => {
  return (
    <div className='h-100 text-center d-flex justify-content-center flex-column pb-5 mt-n5'>
      <h1>Legacy License detected!</h1>
      <h3>
        Please{' '}
        <ProtectedButton variant='link' onClick={onClick} permissions={permissions} key='deleteLegacyLicense'>
          <h3 className='mb-1'>delete</h3>
        </ProtectedButton>{' '}
        the license if you want to use the cluster licensing.
      </h3>
    </div>
  )
}

export const TenantLicenseUsed: FC<{}> = () => {
  return (
    <div className='h-100 text-center d-flex justify-content-center flex-column pb-5 mt-n5'>
      <h1>Tenant License detected!</h1>
      <h3>Your License can only be changed by the Control Cluster.</h3>
    </div>
  )
}

export const CLusterSlotUnavailable: FC<{}> = () => {
  return (
    <div className='h-100 text-center d-flex justify-content-center flex-column pb-5 mt-n5'>
      <h1>Cluster Slot Unavailable!</h1>
      <h3>The node you are trying to access does not have an acquired slot in the cluster. For further information please contact admin.</h3>
    </div>
  )
}
